import React, { useState, useContext, useEffect } from 'react';
import TextInput from '@shared/component/TextInput';
import { AuthContext } from '@shared/context/AuthContext';
import APIService from '@shared/services/api';
import Notify from '@shared/notify';
import { NavLink } from 'react-router-dom';
import CheckValidator from '@shared/checkValidator';
import { encryptPassword } from '../../utils/static/commonUtils';

export function LoginContainer() {
    const [errors, setError] = useState<any>({
        phone: {
            required: true,
            error: true,
            message: 'Please enter phone number',
            pattern: /^[6-9]{1}[0-9]{9}$/,
            maxLength: 10,
        },
        password: {
            required: true,
            error: true,
            message: 'Please enter password',
            maxLength: 20,
        },
    });

    const { setUser, user, setLoader } = useContext(AuthContext);

    const [isSubmit, setIsSubmit] = useState(false);
    const [formData, setFormData] = useState<any>({ phone: null, password: null });
    const [showLoader, setshowLoader] = useState(false);

    const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        try {
            e.preventDefault();
            const isValid: any = await CheckValidator(errors, formData);
            setIsSubmit(!isValid);

            if (!isValid) return;

            callApi();
        } catch (error) {}
    };

    const getValue = (e: any) => {
        try {
            if (e.password) {
                const encryptPass = encryptPassword(e.password);
                setFormData(prevFormData => ({
                    ...prevFormData,
                    password: encryptPass,
                }));
            } else {
                const data = { ...formData, ...e };
                setFormData(data);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const callApi = async () => {
        try {
            setshowLoader(true);
            const { data } = await APIService.post('login', formData, false, true);
            setshowLoader(false);
            if (data.success) {
                const { id, name, phone, user_role, token, demandType } = data.data;
                setUser({ id, name, phone, user_role, token, demandType });
            } else {
                Notify('error', data.message);
            }
        } catch (error) {
            setshowLoader(false);
        }
    };

    return (
        <>
            <main>
                <div className="form_outer_bg lgn-cnt">
                    {showLoader && <div className="loader"></div>}
                    <div className="form_box_cover login_cover">
                        <div className="text_box">
                            <div className="login_box">
                                <img
                                    className="img-responsive"
                                    src="assets/images/login.svg"
                                    style={{ maxWidth: '48px' }}
                                    alt=""
                                />
                            </div>
                            <h2>Welcome to RCM E-Bidding</h2>
                            <p>see demand, make offer & deliver goods</p>
                        </div>
                        <form onSubmit={onSubmit} noValidate>
                            <TextInput
                                data={{
                                    type: 'number',
                                    placeholder: 'Phone number',
                                    name: 'Phone',
                                    id: 'floatingInput',
                                }}
                                controlName="phone"
                                isSubmit={isSubmit}
                                errorMsg={errors?.phone?.message || ''}
                                setValue={(e: any) => getValue(e)}
                                inputProps={errors}
                            />

                            <TextInput
                                data={{
                                    type: 'password',
                                    placeholder: 'Password',
                                    name: 'Password',
                                    id: 'floatingInput',
                                }}
                                controlName="password"
                                isSubmit={isSubmit}
                                errorMsg={errors?.password.message}
                                setValue={(e: any) => getValue(e)}
                                inputProps={errors}
                            />

                            <input className="submit_btn" type="submit" name="" value="Sign in" />
                            {/* <button className="submit_btn" type='submit'>Sign in</button> */}
                        </form>
                        <p className="extra_bottom_text">
                            Forgot your password? <NavLink to="/forgot">Reset Here..</NavLink>
                        </p>
                    </div>
                </div>
            </main>
            <footer>
                <div className="reg_footer_cover">
                    <p>Rcm E-bidding 2024</p>
                </div>
            </footer>
        </>
    );
}
